<template>
  <v-data-table
    dense
    :headers="[
      { text: 'Abreviación', value: 'abbreviation' },
      { text: 'Nombre', value: 'name' },
      { text: 'Codigo', value: 'code' }
    ]"
    sort-by="name"
    :items="amenities"
    :items-per-page="10"
  >
    <template #top>
      <span class=" text-h6 grey--text">
        Amenidades
      </span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "DevelopmentDetailAmenities",
  props: {
    amenities: { type: Array, default: null }
  }
};
</script>

<style scoped>
.card--outlined {
  border: 1px solid #e0e0e0;
  margin: 0.5rem;
}
</style>
